import React, { createContext, useContext, useEffect, useState } from "react";
const MyInstallationOrderContext = createContext({});

export const MyInstallationOrderContextProvider = ({ children }) => {
    const [valueSearch, setValueSearch] = useState(null)
    useEffect(() => {
    }, [])
    return (
        <MyInstallationOrderContext.Provider
            value={{
                valueSearch, setValueSearch
            }}
        >
            {children}
        </MyInstallationOrderContext.Provider>
    );
};

export default function useMyInstallationOrderContext() {
    const context = useContext(MyInstallationOrderContext);
    return context;
}
